export const LOCAL_STORAGE_KEY_SESSION_KEY = 'sessionKey'
export const LOCAL_STORAGE_KEY_MUNICIPALITY = 'municipality'
